module.exports = __webpack_public_path__ + "img/gzh_qrcode.940f8b51.jpg";